import { BEBOP_ROUTES } from "config/consts";
import { Button, ButtonBorderRadius } from "../../general/Button/Button";
import { css } from "@emotion/react";

export const StartTradingButton = () => {
  return (
    <Button
      buttonType="primary"
      navigateTo={BEBOP_ROUTES.Trade}
      data-testid="start-trading-btn"
      text={"Start trading"}
      buttonCss={css`
        padding: 19px 18px;
        justify-content: center;
        align-items: center;
        border-radius: ${ButtonBorderRadius.Mid};
        width: fit-content;
      `}
    />
  );
};
